import {action} from "mobx";
import subCompanyService from "../services/subCompanyService";

class subCompanyStore {
    @action searchCustomers = async (searchText, selectedSubCompanyId) => {
        try {
            const response = await subCompanyService.searchCustomers(searchText, selectedSubCompanyId);
            return response.data;
        } catch (error) {
            return [];
        }
    };
}

export default new subCompanyStore();
